/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Wade Wilkey <wade.wilkey@deliciousai.com>
 */

import { gql } from '@apollo/client'

export const BOUNDING_BOX_FRAGMENT = gql`
  fragment BoundingBox on BoundingBox {
    id
    boxSet {
      id
    }
    detectedLabel
    classifiedLabel
    minX
    minY
    maxX
    maxY
  }
`
